import { Button } from '@talentmesh/ui/components/button';
import { DialogFooter } from '@talentmesh/ui/components/dialog';
import { PlugZap } from 'lucide-react';
import { generatePath, useNavigate } from 'react-router';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';
import UIStrings from '@/Utils/UIStrings';

const AtsNotConnectedNotice = () => {
    const companyId = useCompanyId();
    const navigate = useNavigate();

    const handleGoToSettings = () => {
        navigate(generatePath(RoutePath.AccountSettingsIntegrations, { companyId }));
    };

    return (
        <>
            <div className="flex flex-col items-center gap-3 py-6 text-center" data-cy="AtsNotConnectedNotice">
                <div className="bg-muted text-muted-foreground rounded-full p-3">
                    <PlugZap className="size-6" aria-hidden />
                </div>
                <p className="text-secondary-foreground text-base font-semibold">{UIStrings.AtsNotConnectedTitle}</p>
                <p className="text-muted-foreground max-w-md text-sm">{UIStrings.AtsNotConnectedDescription}</p>
                <p className="text-muted-foreground max-w-md text-sm">{UIStrings.AtsNotConnectedAdminHint}</p>
            </div>
            <DialogFooter className="gap-2 sm:justify-end">
                <Button type="button" onClick={handleGoToSettings} data-cy="AtsGoToIntegrationSettings">
                    {UIStrings.GoToIntegrationSettings}
                </Button>
            </DialogFooter>
        </>
    );
};

export default AtsNotConnectedNotice;

